import React from 'react';
import { Dialog, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const Popup = ({ open, message, subMessage, onCancel, onConfirm }) => {
  const { t } = useTranslation();
  return (
  <Dialog open={open} onClose={onCancel} PaperProps={{
    sx: {
      borderRadius: '20px',
      background: '#FFF',
      display: 'flex',
      width: '320px',
      paddingTop: '20px',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '20px'
    }
  }}>
    <DialogContent sx={{ display: 'flex',
        minHeight: '90px',
        padding: '0px 20px',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '10px',
        alignSelf: 'stretch' }}>
      <Typography sx={{
        alignSelf: 'stretch',
        color: 'rgba(0, 0, 0, 0.60)',
        fontSize: '15px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: 'normal',
        letterSpacing: '-0.45px'
      }}>
        {message}
      </Typography>
      {subMessage && (
        <Typography sx={{
            alignSelf: 'stretch',
            color: 'rgba(0, 0, 0, 0.30)',
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: 'normal',
            letterSpacing: '-0.36px'
        }}>
          {subMessage}
        </Typography>
      )}
    </DialogContent>
    <DialogActions disableSpacing 
        sx={{      
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'stretch', 
        p:0      
      }}
    >
    {onCancel && (
      <Button
        onClick={onCancel}
        sx={{          
          display: 'flex',
          padding: '16px 0',
          justifyContent: 'center',
          alignItems: 'center',
          flex: '1 0 0',
          background: 'rgba(0, 0, 0, 0.10)',
          color: '#211F20',
          textAlign: 'center',
          fontFeatureSettings: "'liga' off, 'clig' off",
          fontSize: '15px',
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: 'normal',
          letterSpacing: '-0.45px',
          borderRadius: '0 0 0 20px',      
          '&:hover': { bgcolor: '#e0e0e0' }
        }}
      >
        {t('common_cancel')}
      </Button>
    )}
      <Button
        onClick={onConfirm}
        sx={{        
            display: 'flex',
            padding: '16px 0',
            justifyContent: 'center',
            alignItems: 'center',            
            flex: '1 0 0',
            background: '#FF43AA',
            color: '#FFF',
            textAlign: 'center',
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontSize: '15px',
            fontStyle: 'normal',
            fontWeight: 600,
            lineHeight: 'normal',
            letterSpacing: '-0.45px',
            borderRadius: '0 0 20px 0',            
            '&:hover': { bgcolor: '#e13b97' }
        }}
      >
        {t('common_confirm')}
      </Button>
    </DialogActions>
  </Dialog>
)};

export default Popup;